module.exports = __webpack_public_path__ + "img/undraw_cart.c672d342.svg";